import { useLocation, useNavigate } from 'react-router-dom'
import { Security } from '@okta/okta-react'
import { toRelativeUrl } from '@okta/okta-auth-js'
import Routing from './pages/Routing'
import Header from './common/components/header/Header'
import { ApolloProvider } from '@apollo/client'
import { createApolloClient } from './config/Apollo'
import './common/styles/Layout.scss'
import './common/styles/Labels.css'
import './common/styles/EdsOverrides.css'
import { oktaAuth } from './config/OktaConfig'
import { useCallback, useEffect } from 'react'
import { logUsage } from './services/usageLog'
import { Banner } from './common/components/banner/Banner'
import { CarriersProvider } from './services/CarriersProvider'
import { Footer } from './common/components/footer/Footer'
import './common/styles/App.css'

const apolloClient = createApolloClient(oktaAuth)

function usePageViews() {
  const location = useLocation()
  useEffect(() => {
    const page = location.pathname.startsWith('/')
      ? location.pathname.split('/')[1]
      : location.pathname
    logUsage(page, 'load')
  }, [location])
}

function App() {
  usePageViews()
  const navigate = useNavigate()

  const restoreOriginalUri = useCallback(
    (_oktaAuth: any, originalUri: string) => {
      navigate(toRelativeUrl(originalUri || '/', window.location.origin), { replace: true })
    },
    [navigate]
  )

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <ApolloProvider client={apolloClient}>
        <CarriersProvider>
          <Header />
          <Banner />
          <main style={{ padding: 'var(--eds-space-8) var(--eds-space-24)' }}>
            <Routing />
          </main>
          <Footer />
        </CarriersProvider>
      </ApolloProvider>
    </Security>
  )
}

export default App
